import get from 'lodash/get';

export const getVisibleData = (config, sources) => {
  const visible = get(config, 'data.datasets', [])
    .filter(({ label }) => sources.includes(label.split('.')[0]))
    .reduce((res, { label, data }) => {
      const type = label.split('.')[1];

      return res.set(type, [...(res.get(type) || []), ...data]);
    }, new Map());

  return [...visible.entries()];
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/helpers/getVisibleData.js